import { useEffect, useRef } from "react";
import { useStore } from "../context/StoreContext";

// Converts big wins from the store into notification-center entries. No
// floating "sticky" card anymore — users open the bell to see & share.
const BragOnWin = () => {
  const { bigWin, dismissBigWin, pushNotification } = useStore();
  const seenRef = useRef(new Set());

  useEffect(() => {
    if (!bigWin) return;
    if (seenRef.current.has(bigWin.id)) return;
    seenRef.current.add(bigWin.id);
    pushNotification({
      kind: "brag",
      emoji: bigWin.emoji || "🏆",
      title: bigWin.title || "Big win!",
      body: bigWin.subtitle || "Tap Make card to share.",
      coins: bigWin.coins || 0,
    });
    dismissBigWin();
  }, [bigWin, pushNotification, dismissBigWin]);

  return null;
};

export default BragOnWin;
